// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"HeaderItems_NavigationItems_2Cjjs"};